<template>
  <section>
    <v-dialog v-model="$store.state.pdfDialog.show" max-width="1000" persistent>
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="maximize">
            <v-icon> mdi-window-maximize </v-icon>
          </v-btn>
          <v-btn icon @click="close">
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <iframe width="100%" height="700px" :src="$store.state.pdfDialog.src"></iframe>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="close"> Close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
  export default {
    methods: {
      maximize() {
        var fullScreenWindow = window.open();
        fullScreenWindow.document.write(
          `<iframe src="${this.$store.state.pdfDialog.src}" height="100%" width="100%"></iframe>`
        );
        this.close();
      },
      close() {
        this.$store.commit('closePdfDialog');
      },
      // beforeOpen() {
      // // Prevent background scorll issue
      // document.documentElement.classList.add("overflow-y-hidden");
      // },
      // beforeClose() {
      // // Prevent background scorll issue
      // document.documentElement.classList.remove("overflow-y-hidden");
      // },
    },
  };
</script>
